export default "__VITE_ASSET__DSiMbEum__"